// Shared visual constants for the Dashboard widgets.
//
// Originally these lived inline at the top of DashboardPage.js. Splitting
// them out keeps each widget file self-contained while preserving the
// brand palette as the single source of truth.

import {
  Workflow, FolderKanban, Gauge, Target, Zap, Award, Users, Euro, CircleDot,
} from 'lucide-react';

// KAIZEN KANRI brand palette (mirrors the logo).
export const BRAND = {
  cyan: '#00CED1',
  cyanLight: '#E0FFFE',
  cyanDark: '#008B8D',
  dark: '#0a0a0a',
  charcoal: '#1a1a2e',
  emerald: '#10b981',
  amber: '#f59e0b',
  rose: '#ef4444',
  blue: '#3b82f6',
  violet: '#8b5cf6',
  slate: '#64748b',
};

export const DONUT_COLORS = ['#94a3b8', BRAND.emerald, BRAND.cyan];
export const PHASE_COLORS_ARR = [BRAND.cyan, BRAND.blue, BRAND.amber, BRAND.emerald, BRAND.rose];
export const DEPT_COLORS = [BRAND.cyan, BRAND.emerald, BRAND.blue, BRAND.violet, BRAND.amber, BRAND.rose, BRAND.slate];

export const GOAL_CAT_ICONS = {
  process_management: Workflow,
  project_management: FolderKanban,
  process_control: Gauge,
  lean_six_sigma: Target,
  continuous_improvement: Zap,
  operational_excellence: Award,
  people_culture: Users,
  financial_impact: Euro,
  custom: CircleDot,
};

export const GOAL_STATUS_COLORS = {
  not_started: '#94a3b8',
  on_track: '#10b981',
  at_risk: '#f59e0b',
  behind: '#ef4444',
  completed: '#00CED1',
};
